import { Box, Button, Paper } from '@mui/material';
import {
  add,
  differenceInDays,
  getDay,
  getMonth,
  getYear,
  set,
} from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { useQuery } from 'react-query';
import {
  Area,
  Bar,
  CartesianGrid,
  ComposedChart,
  Label,
  Legend,
  Line,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { useRecoilValue } from 'recoil';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { getDayOfWeek, getMonthText, getTypeWord } from '../../common/helper';
import NoDataPage from '../commonComponent/NoDataPage';
import { SwTitleDownloadMore } from '../commonComponent/SwTitleDownloadMore';
import { SwRwwTab } from '../commonComponent/SwRwwTab';
import { RwwCumulativeGraphByGender } from './RwwCumulativeGraphByGender';
import {
  KEY_CUMULATIVE,
  KEY_EDUCATION_OFFICE_MONTHLY_MEMBER_LIST,
  KEY_EDUCATION_OFFICE_MONTHLY_READ_STAT_LIST,
  KEY_EDUCATION_OFFICE_MONTHLY_WALK_STAT_LIST,
  KEY_EDUCATION_OFFICE_MONTHLY_WRITE_STAT_LIST,
  KEY_READ_TEXT,
  KEY_WALK_TEXT,
  KEY_WRITE_TEXT,
} from '../../common/key';

import { getClassMonthlyReadRankList } from '../../common/api/ApiClassStat';
import {
  downloadEducationOfficeMonthlyDataList,
  downloadEducationOfficeMonthlyMemberData,
  getEducationOfficeMonthlyMemberList,
  getEducationOfficeMonthlyReadStatList,
  getEducationOfficeMonthlyWalkStatList,
  getEducationOfficeMonthlyWriteStatList,
} from '../../common/api/ApiEducationOffice';
import { educationOfficeInfoState } from '../../common/atom';
import { RwwMemberGraphByGender } from './RwwMemberGraphByGender';

interface Props {
  startDate: number;
  from?: string;
  isPdf?: boolean;
}

export const RwwMemberStatistics: React.FC<Props> = ({
  startDate,
  from = 'dashboard',
  isPdf = false,
}) => {
  const educationOfficeInfo = useRecoilValue(educationOfficeInfoState);
  const [educationOfficeSeq, setEducationOfficeSeq] = useState<number>(0);
  const [reqRequest, setReqRequest] = useState<boolean>(false);
  const [requestData, setRequestData] = useState<any>();
  const [requestReadData, setRequestReadData] = useState<any>();
  const [requestWalkData, setRequestWalkData] = useState<any>();
  const [requestWriteData, setRequestWriteData] = useState<any>();
  const [rowCount, setRowCount] = useState<number>(1);
  const [rateData, setRateData] = useState<any>([]);
  const { width, ref } = useResizeDetector();
  const [loading, setLoading] = useState<any>(false);
  const [statType, setStatType] = useState<string>(KEY_READ_TEXT);

  const {
    data,
    isLoading,
    refetch: refetchEducationOfficeMonthlyMember,
  } = useQuery(
    KEY_EDUCATION_OFFICE_MONTHLY_MEMBER_LIST,
    () => {
      if (reqRequest) {
        const newData: any = {
          educationOfficeSeq: educationOfficeSeq,
          year: getYear(startDate * 1000),
        };
        return getEducationOfficeMonthlyMemberList(newData);
      }
      return null;
    },
    {
      onSuccess: res => {
        setLoading(false);
        if (res !== null) {
          setRequestData(res);
        } else {
          setRequestData(null);
        }
      },
      onError: e => {
        setLoading(false);
        console.log(e);
      },
    }
  );

  const downloadClassMonthlyData = () => {
    const newData: any = {
      educationOfficeSeq: educationOfficeSeq,
      year: getYear(startDate * 1000),
    };
    downloadEducationOfficeMonthlyMemberData(newData);
  };

  useEffect(() => {
    if (reqRequest) {
      refetchEducationOfficeMonthlyMember();
    }
  }, [educationOfficeSeq]);

  useEffect(() => {
    if (
      educationOfficeInfo.educationOfficeSeq !== undefined &&
      educationOfficeInfo.educationOfficeSeq !== null
    ) {
      setEducationOfficeSeq(educationOfficeInfo.educationOfficeSeq);
    }
  }, [educationOfficeInfo]);

  useEffect(() => {
    if (reqRequest) {
      refetchEducationOfficeMonthlyMember();
    }
  }, [startDate]);

  useEffect(() => {
    if (reqRequest) {
      refetchEducationOfficeMonthlyMember();
    }
  }, [reqRequest]);

  useEffect(() => {
    setReqRequest(true);
  }, []);

  return (
    <>
      <Paper sx={{ backgroundColor: '#fff' }}>
        <Box className='flex_between'>
          <SwTitleDownloadMore title='교육청 사용자 수 데이터' />
          <Button
            sx={{ ml: '1rem' }}
            color='info'
            onClick={downloadClassMonthlyData}
          >
            데이터 다운로드
            <FileDownloadRoundedIcon color='success' />
          </Button>
        </Box>
        <RwwMemberGraphByGender
          stepsGoalRateAverage={[false, false]}
          startDate={startDate}
          totalAverage={requestData?.totalRate ?? 0}
          data={requestData?.statList}
          isPdf={false}
        />
      </Paper>
    </>
  );
};
